import { createAction } from 'redux-actions-helpers'
import { CourseType, ThemeType } from './types'

export const fetchCourse = createAction(
  '@@admin-edit-course/FETCH_COURSE',
  (id: string): any => ({ id })
)

export const fetchCourseSuccess = createAction(
  '@@admin-edit-course/FETCH_COURSE_SUCCESS',
  (result: CourseType): any => ({ result })
)

export const fetchCourseFailure = createAction(
  '@@admin-edit-course/FETCH_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const fetchThemes = createAction(
  '@@admin-edit-course/FETCH_THEMES',
  (id: string): any => ({ id })
)

export const fetchThemesSuccess = createAction(
  '@@admin-edit-course/FETCH_THEMES_SUCCESS',
  (result: ThemeType[]): any => ({ result })
)

export const fetchThemesFailure = createAction(
  '@@admin-edit-course/FETCH_THEMES_FAILURE',
  (error: string): any => ({ error })
)

export const editCourse = createAction(
  '@@admin-edit-course/EDIT_COURSE',
  (
    id: string,
    title: string,
    status: string,
    starts_at: string,
    auto_subscription: boolean
  ): any => ({
    id,
    title,
    status,
    starts_at,
    auto_subscription,
  })
)

export const editCourseSuccess = createAction(
  '@@admin-edit-course/EDIT_COURSE_SUCCESS',
  (result: CourseType): any => ({ result })
)

export const editCourseFailure = createAction(
  '@@admin-edit-course/EDIT_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const removeCourse = createAction(
  '@@admin-edit-course/REMOVE_COURSE',
  (id: string): any => ({ id })
)

export const removeCourseSuccess = createAction(
  '@@admin-edit-course/REMOVE_COURSE_SUCCESS'
)

export const removeCourseFailure = createAction(
  '@@admin-edit-course/REMOVE_COURSE_FAILURE',
  (error: string): any => ({ error })
)

export const createTheme = createAction(
  '@@admin-edit-course/CREATE_THEME',
  (id: string, title: string, color: string): any => ({ id, title, color })
)

export const createThemeSuccess = createAction(
  '@@admin-edit-course/CREATE_THEME_SUCCESS'
)

export const createThemeFailure = createAction(
  '@@admin-edit-course/CREATE_THEME_FAILURE',
  (error: string): any => ({ error })
)

export const fetchCourseStatistic = createAction(
  '@@admin-edit-course/FETCH_COURSE_STATISTIC',
  (id: string): any => ({ id })
)

export const fetchCourseStatisticSuccess = createAction(
  '@@admin-edit-course/FETCH_COURSE_STATISTIC_SUCCESS',
  (result: string): any => ({ result })
)

export const fetchCourseStatisticFailure = createAction(
  '@@admin-edit-course/FETCH_COURSE_STATISTIC_FAILURE',
  (error: string): any => ({ error })
)

export const editTheme = createAction(
  '@@admin-edit-course/EDIT_THEME',
  (id: string, themeId: string, title: string, color: string): any => ({
    id,
    themeId,
    title,
    color,
  })
)

export const editThemeSuccess = createAction(
  '@@admin-edit-course/EDIT_THEME_SUCCESS'
)

export const editThemeFailure = createAction(
  '@@admin-edit-course/EDIT_THEME_FAILURE',
  (error: string): any => ({ error })
)

export const removeTheme = createAction(
  '@@admin-edit-course/REMOVE_THEME',
  (id: string, themeId: string): any => ({ id, themeId })
)

export const removeThemeSuccess = createAction(
  '@@admin-edit-course/REMOVE_THEME_SUCCESS'
)

export const removeThemeFailure = createAction(
  '@@admin-edit-course/REMOVE_THEME_FAILURE',
  (error: string): any => ({ error })
)

export const createMap = createAction(
  '@@admin-edit-course/CREATE_MAP',
  (course_id: string, image: File, is_active: boolean): any => ({
    course_id,
    image,
    is_active,
  })
)

export const createMapSuccess = createAction(
  '@@admin-edit-course/CREATE_MAP_SUCCESS'
)

export const createMapFailure = createAction(
  '@@admin-edit-course/CREATE_MAP_FAILURE',
  (error: string): any => ({ error })
)

export const removeMap = createAction(
  '@@admin-edit-course/REMOVE_MAP',
  (course_id: string, map_id: string): any => ({ course_id, map_id })
)

export const removeMapSuccess = createAction(
  '@@admin-edit-course/REMOVE_MAP_SUCCESS'
)

export const removeMapFailure = createAction(
  '@@admin-edit-course/REMOVE_MAP_FAILURE',
  (error: string): any => ({ error })
)

export const destroy = createAction('@@admin-edit-course/DESTROY')
